import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useGetProvinces = () => {
	const { accessToken } = useTokenStore();

	const get = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get("provinces");
		return res.data?.data;
	};

	return useQuery(["provinces"], () => get(), {
		...fetchConfig,
	});
};

export default useGetProvinces;
